import { createContext } from 'react';
import type {
  TExperienceAnswersContextValue,
  TExperienceContextValue,
} from './Experience.types.ts';

export const ExperienceContext = createContext<
  TExperienceContextValue | undefined
>(undefined);

export const ExperienceAnswersContext = createContext<
  TExperienceAnswersContextValue | undefined
>(undefined);
